import {
  apiClient,
  ApiClientConfig,
  PaginatedRequestParams,
  PaginatedResponse,
} from 'api';
import { apiReportExport } from 'api/export.report';
import { User } from 'types';
type userMenu = {
  id: string;
  menu: string;
  isPermission: boolean;
}
export interface GetUserListResponse extends User {
  "Menu": userMenu[]
}

interface BaseResponse<T> {
  rs: number;
  res?: T;
  rc?: any[]; // if this is always an array, or refine as needed
  msgkey?: string | null;
  ukey?: string;
  customMessage?: string;
  itemId?: number;
  totalRecords?: number;
}
export type SupplierResponse = BaseResponse<PaginatedResponse<User>>;

export const ReportApiService = () => {
  const getReportViewList = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<SupplierResponse>({
      ...callConfig,
      endpoint: `AdminWeighbridge/VisitReport`,
      params,
    });

    return response.data;
  };
  const getReportCommonList = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<SupplierResponse>({
      ...callConfig,
      endpoint: `EntryGate/GetCommonMasterList`,
      params,
    });

    return response.data;
  };
  const getReportTableData = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<SupplierResponse>({
      ...callConfig,
      endpoint: `AdminWeighbridge/VisitReportTableData`,
      params,
    });

    return response.data;
  };

// const getDownloadReportTableData = async (
//   params: Record<string, any>,
//   fileName = "report.csv",
// ) => {
//   try {
//     const response = await apiClient<Blob>({
//       endpoint: "/AdminWeighbridge/DownloadVisitReportTableData",
//       method: "GET",
//       params,
//       responseType: "blob",
//     }as any);

//     const blob = new Blob([response.data], {
//       type: "text/csv;charset=utf-8;",
//     });

//     const url = window.URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.href = url;
//     link.download = fileName;

//     document.body.appendChild(link);
//     link.click();

//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   } catch (error) {
//     console.error("Failed to download CSV report:", error);
//   }
// };

const getDownloadReportTableData = async (
  data: Record<string, any>
) => {
  
  try {
    const response = await apiReportExport({
      endpoint: "/AdminWeighbridge/DownloadVisitReportTableDataExcel",
      method: "GET",
      data,
      responseType: "blob",
    } as any);

    const contentDisposition = response.headers?.["content-disposition"];
    let fileName = "VisitReport_Grouped.xlsx";

  if (contentDisposition) {
  // Split by ';' in case there are multiple parts
    const parts = contentDisposition.split(';');

    // First try normal filename
    const filenamePart = parts.find(p => p.trim().startsWith('filename='));
    if (filenamePart) {
      // Remove filename= and quotes
      fileName = filenamePart
        .trim()
        .replace(/^filename="?/, '')
        .replace(/"$/, '');
    } else {
      // fallback: parse RFC5987 filename_ part
      const filenameEncodedPart = parts.find(p => p.trim().startsWith('filename_'));
      if (filenameEncodedPart) {
        // Remove filename_=UTF-8'' prefix
        fileName = decodeURIComponent(
          filenameEncodedPart.trim().replace(/^filename_\*?=UTF-8''/, '')
        );
      }
    }
  }

    // ✅ THIS LINE FIXES EVERYTHING
    const blob = response.data as Blob;

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);



  } catch (error) {
    console.error("Failed to download report:", error);
  }
};

 


  return {
    getReportViewList,
    getReportCommonList,
    getReportTableData,
    getDownloadReportTableData
  };
};
